import aa from 'search-insights';
import Cookies from 'js-cookie';

// This should not be changing between renders, so there's no need
// to recreate the value every thing the component renders
export const GOOGLE_INDEX_NAME = process?.env?.GOOGLE_INDEX_JOBS;

/**
 * Checks for a tracking cookie set from a job search/listing page
 * this cookie should follow this format in its shape:
 * <queryIdHash>--<userSelectedJobSlug>--<ctsJobName>
 *
 * @returns {{placedHash: *, queryID: *, ctsName: *}}
 */
export const retrieveSearchTrackingCookieData = () => {
    const searchTrackingCookieData = Cookies.get('fgb_job_search_query_id');

    // parse out the cookie to obtain the two values in a tuple
    const [queryID, placedHash, ctsName] = searchTrackingCookieData
        ? searchTrackingCookieData.split('--')
        : [null, null, null];

    return {
        queryID,
        placedHash,
        ctsName,
    };
};

/**
 * Sets cookie with query and job data
 * @param queryID
 * @param hash
 * @param ctsName
 */
export const handleFiringSearchEmitterOnSearchResult = ({
    queryID,
    hash,
    ctsName,
}) => {
    // we also set a cookie, so that if they click the apply button on the single
    // job page after searching for this result, we mark that as a conversion.
    Cookies.set('fgb_job_search_query_id', `${queryID}--${hash}--${ctsName}`, {
        expires: 1,
    });
};

/**
 * @deprecated no longer emitting events to Algolia since Google CTS Implementation
 * handle firing off the algolia jawn if qualifications are met
 */
export const handleFiringNonSearchEmitter = (hash = '', pos = '', altLabel) => {
    // not on the client? bail.
    if (typeof window === 'undefined') return false;

    const { algoliaQueryID, placedHash } = retrieveSearchTrackingCookieData();

    // If the conversion has nothing to do with a search, we still want to track it,
    // however, we will have to use a different method that does not require the cookie
    // query id
    if (
        !algoliaQueryID || // there is no existing query id from the cookie
        !GOOGLE_INDEX_NAME || // if there is no algolia index name present
        placedHash !== hash // or the hash stored in the cookie does not match the current slug
    ) {
        aa('convertedObjectIDs', {
            index: GOOGLE_INDEX_NAME,
            eventName: `Nonquery applied to job via ${pos} button on sjp`,
            objectIDs: [hash],
        });

        return true;
    }

    // We've made it this far. Let's fire off to Algolia.
    // The eventName contains the position of the button that
    // the user used to trigger the event
    aa('convertedObjectIDsAfterSearch', {
        eventName: altLabel ?? `Query  applied to job via ${pos} button on sjp`,
        objectIDs: [hash],
        queryID: algoliaQueryID,
        index: GOOGLE_INDEX_NAME,
    });

    return true; // return true because we successfully completed
};
